<script setup lang="ts">
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import i18n from '@/lang/i18n';

const props = defineProps<{
  deliveryPlan?: getDeliveryPlanVehicleInformation;
}>();
</script>
<template>
  <v-col cols="12">
    <div class="mb-1">
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.splitForm.tripId') }}
      </span>
      {{ props.deliveryPlan?.delivery_plan_id }}
    </div>
    <div class="mb-1">
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.splitForm.carNumber') }}
      </span>
      {{ props.deliveryPlan?.car_number }}
    </div>
    <div>
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.splitForm.driver') }}
      </span>
      {{ props.deliveryPlan?.driver?.full_name }}
    </div>
  </v-col>
</template>
